import { Dispatch, SetStateAction, useRef } from "react";
import { Row, Col, Button, Badge } from "reactstrap";
import { useParams } from "react-router-dom";
import { Whisper, Popover } from "rsuite";

import DropdownOptionWithIcon, {
  MdiIconType,
} from "../../Menus/DropdownOptionWithIcon";
import DropdownMenuDivider from "../../Menus/DropdownMenuDivider";
import PopoverDropdownMenu from "../../Menus/PopoverDropdownMenu";
import { deleteFileBlobStorage } from "../../../utils/FileUtils";
import FileWithOptions from "./FileWithOptions";
import UppyFile from "../../Inputs/UppyFile";

interface Props {
  field: any;
  fileData: any;
  type?: "Image" | "Video" | "Audio" | "Text" | "Data" | "SingleFile" | null;
  options: any;
  titleOptions: string;
  afterUpload: (item: any) => void;
  closeRecord: () => void;
  setData: (data: any) => void;
  setFile: (data: any) => void;
  openModal: () => void;
  onDelete: (value: any) => void;
  multiFiles: boolean;
  setKeepOpen: Dispatch<SetStateAction<boolean>>;
}

export default function EditingPopup({
  field,
  fileData,
  type,
  options,
  titleOptions,
  closeRecord,
  afterUpload,
  setData,
  setFile,
  openModal,
  onDelete,
  multiFiles,
  setKeepOpen,
}: Props) {
  const whisperOptionsRef = useRef<any>();
  const { formID, tenantID }: any = useParams();

  const FileOptions = ({ value }: any) => {
    return (
      <PopoverDropdownMenu>
        <h5
          style={{ maxWidth: 250 }}
          className="px-2 pt-2 text-dark text-truncate"
        >
          {value.Name}
        </h5>
        <DropdownMenuDivider />
        <DropdownOptionWithIcon
          name="Open Preview"
          icon="mdi mdi-file-find"
          onClick={() => {
            openModal();
            setFile(value);
          }}
        />
        <DropdownMenuDivider />
        <DropdownOptionWithIcon
          name="Delete File"
          icon="mdi mdi-delete"
          onClick={() =>
            deleteFileBlobStorage({
              filePath: value.File,
              recordID: "",
              moduleAPIName: "",
              fieldAPIName: "",
              onSuccess: () => {
                setData((prev: any) => {
                  const newValues = prev.filter(
                    (val: any) => val.File !== value.File
                  );
                  whisperOptionsRef.current?.close();
                  onDelete(newValues);
                  return newValues;
                });
              },
            })
          }
        />
      </PopoverDropdownMenu>
    );
  };

  return (
    <div className="p-0" style={{ borderRadius: "5px", width: "100%" }}>
      <div className="p-2 border-bottom border-superlight">
        <Row className="align-items-center">
          <Col xs="" className="pr-2 d-flex">
            <h5 className="m-0 pr-2">{field?.Name ? field?.Name : "Image"}</h5>
            <Badge color="light">{field?.Public ? "Public" : "Private"}</Badge>
          </Col>
          <Col className="pl-0" xs="auto">
            {fileData?.lenght && (
              <Whisper
                ref={whisperOptionsRef}
                placement="autoVerticalEnd"
                trigger={"click"}
                speaker={
                  <Popover className="sidebar-popover" full>
                    <PopoverDropdownMenu>
                      {titleOptions && (
                        <>
                          <h5 className="px-2 pt-2 text-dark">
                            {titleOptions}
                          </h5>
                          <DropdownMenuDivider />
                        </>
                      )}
                      {options?.map((option: any, i: number) => {
                        return (
                          <DropdownOptionWithIcon
                            key={`${option.name}-${i}`}
                            name={option.name}
                            icon={`mdi ${option.icon}` as MdiIconType}
                            onClick={option.action}
                          />
                        );
                      })}
                    </PopoverDropdownMenu>
                  </Popover>
                }
              >
                <Button
                  disabled={fileData ? false : true}
                  size="sm"
                  outline
                  color="secondary"
                  className="btn-icon-only"
                >
                  <i
                    style={{ fontSize: "" }}
                    className="mdi mdi-dots-horizontal"
                  ></i>
                </Button>
              </Whisper>
            )}
            <Button
              size="sm"
              outline
              color="secondary"
              onClick={(e) => {
                e.preventDefault();
                closeRecord();
              }}
            >
              Done
            </Button>
          </Col>
        </Row>
      </div>
      {fileData?.length > 0 ? (
        <>
          {fileData.map((f: any, i: number) => {
            return (
              <>
                {/** @ts-ignore */}
                <FileWithOptions
                  key={i}
                  item={f}
                  index={0}
                  isFirst={true}
                  FileOptions={FileOptions}
                />
              </>
            );
          })}
        </>
      ) : (
        <></>
      )}
      <hr className="p-0 m-0" />
      <div className="p-2">
        <Row className="align-items-center">
          <Col xs="" className="pr-2">
            <UppyFile
              afterSubmit={afterUpload}
              multiFiles={multiFiles}
              fileType={type}
              meta={{ isPublic: !!field?.Public }}
              endpoint={
                formID
                  ? `/tenant/publicForms/file/${formID}/${tenantID}`
                  : undefined
              }
              filesToFilter={
                fileData
                  ? Array.isArray(fileData)
                    ? fileData
                    : [fileData]
                  : []
              }
              setKeepOpen={setKeepOpen}
            />
          </Col>
        </Row>
      </div>
    </div>
  );
}
